import React, {memo} from 'react'
import {Accordion, Button, Header} from 'semantic-ui-react'
import {
  withChildPathProps,
  withErrorHandling,
  withHelmet,
  withMeData,
  withNavigation,
  withPropsPresent,
  withServiceData,
  withVersionData
} from '../../../../hoc'
import {Actions} from '../../../shared'
import {cloneEnvironment} from '../../../../backend'
import {useSafeState} from '../../../../hook'
import {coerceToISODate, toLocaleDateString, userAccount} from '../../../../util'

const getPathPrefix = (serviceId, versionId) => {
  const basePath = '/c/services/:serviceId/versions/:versionId/environments'
  return basePath
    .replace(':serviceId', serviceId)
    .replace(':versionId', versionId)
}

const _Environments = (props) => {
  let {
    me,
    service,
    version,
    environmentId,
    mutateVersion,
    cloneEnvironment,
    navigate,
    children
  } = props

  const [state, setState] = useSafeState({cloning: '', menuOpen: false})
  let activeIndex = -1
  const environment = version.environments.find(e => e.id === environmentId)
  if (environment) {
    activeIndex = version.environments.indexOf(environment)
  }
  const onSelect = async (titleProps) => {
    const {index} = titleProps
    const newIndex = activeIndex === index ? -1 : index
    if (newIndex > -1) {
      const environment = version.environments[newIndex]
      navigate(`${getPathPrefix(service.id, version.id)}/${environment.id}/resources`)
    } else {
      navigate(getPathPrefix(service.id, version.id))
    }
  }

  const onAdd = (e) => {
    navigate(`${getPathPrefix(service.id, version.id)}/add`)
  }

  const onEdit = (environment) => {
    navigate(`${getPathPrefix(service.id, version.id)}/${environment.id}/edit`)
  }

  const onRemove = (environment) => {
    navigate(`${getPathPrefix(service.id, version.id)}/${environment.id}/remove`)
  }

  const onClone = async (environment) => {
    setState({...state, cloning: environment.id})
    const cloned = await cloneEnvironment(environment.id)
    setState({...state, cloning: ''})
    mutateVersion()
    navigate(`${getPathPrefix(service.id, version.id)}/${cloned.id}/resources`)
  }

  const onArchive = (environment) => {
    navigate(`${getPathPrefix(service.id, version.id)}/${environment.id}/archive`)
  }

  const account = userAccount(me)
  const port = ['', '80'].includes(window.location.port.toString()) ? '' : `:${window.location.port}`

  const panels = version.environments.map((env, i) => {
    return {
      key: `${env.id}`,
      title: {
        key: `title-${env.id}`,
        content: (
          <div style={{display: 'inline'}} data-test="environment-title">
            <span>{env.name}</span>
            <Actions
              prefix="environment"
              onEdit={() => onEdit(env)}
              onClone={() => onClone(env)}
              onRemove={() => onRemove(env)}
              onArchive={() => onArchive(env)}
              style={{float: 'right'}}
            />
            <div style={{clear: 'right'}}/>
          </div>
        )
      },
      content: {
        key: `content-${env.id}`,
        content: (
          <div data-test="environment-content">
            {
              activeIndex === i && (
                <div>
                  <div>
                    <div style={{marginBottom: '15px'}}>
                      <div style={{fontWeight: 'bold'}}>Last Accessed At:</div>
                      <div
                        data-test="environment-base-url">
                        {env.lastAccessedAt ? toLocaleDateString(coerceToISODate(env.lastAccessedAt)) : 'n/a'}
                      </div>
                    </div>
                    {
                      !service.internalURL && (
                        <div style={{marginBottom: '15px'}}>
                          <div style={{fontWeight: 'bold'}}>Mock Base URL:</div>
                          <div
                            data-test="environment-base-url">{`${window.location.protocol}//${window.location.hostname}${port}/m/${account.name}/${service.name}/${version.name}/${env.name}`}</div>
                        </div>
                      )
                    }
                    {
                      service.internalURL && (
                        <div style={{marginBottom: '15px'}}>
                          <div style={{fontWeight: 'bold'}}>Mock Base URL:</div>
                          <div
                            data-test="environment-base-url">{`${service.internalURL}/m/${account.name}/${service.name}/${version.name}/${env.name}`}</div>
                        </div>
                      )
                    }
                    {
                      service.security.enabled && (
                        <div style={{marginBottom: '15px'}}>
                          <div style={{fontWeight: 'bold'}}>API Key (via 'x-smocks-api-key' header):</div>
                          <div data-test="environment-api-key">{service.security.apiKey}</div>
                        </div>
                      )
                    }
                    <div style={{clear: 'left', marginBottom: '15px'}}/>
                    {
                      !!environment && children
                    }
                  </div>
                  <div style={{clear: 'left'}}/>
                </div>
              )
            }
          </div>
        )
      }
    }
  })

  return (
    <div>
      <Header as="h4" dividing>Environments</Header>
      <>
        {
          version.environments.length > 0 && (
            <Accordion fluid
                       styled
                       activeIndex={activeIndex}
                       panels={panels}
                       data-testid="environments"
                       onTitleClick={(e, titleProps) => onSelect(titleProps)}/>
          )
        }
        {
          version.environments.length === 0 && (
            <div data-testid="environments">
              No environments defined
            </div>
          )
        }
        <Button size="tiny"
                basic
                primary
                icon="add"
                data-testid="environments-add-button"
                content="Add Environment"
                style={{marginTop: '25px'}}
                onClick={(e) => onAdd(e)}/>
      </>
      {
        !environment && children
      }
    </div>
  )
}


let Environments = (props) => {
  const {handleError} = props
  props = {
    ...props,
    cloneEnvironment: handleError(cloneEnvironment)
  }
  return (<_Environments {...props}/>)
}

Environments = withPropsPresent(Environments, ['service', 'version'])
Environments = withHelmet(Environments, 'Environments')
Environments = withMeData(Environments, 'Loading env profile...')
Environments = withVersionData(Environments, 'Loading version...')
Environments = withServiceData(Environments, 'Loading service...')
Environments = withNavigation(Environments)
Environments = withChildPathProps(Environments)
Environments = withErrorHandling(Environments)
Environments = memo(Environments)

export {_Environments, Environments}

export default Environments